import { config } from '@/pageConfig/lemonadeGoesGlobal/fr/fr';
import type { Data } from '@/pageTemplate/LemonadeGoesGlobalPageTemplate';
import { LemonadeGoesGlobalPageTemplate } from '@/pageTemplate/LemonadeGoesGlobalPageTemplate';
import { getAvailabilityByRegion } from '@/utils/getAvailabilityByRegion';

export default function LemonadeGoesGlobalPage({ data }: { data: Data }) {
  return <LemonadeGoesGlobalPageTemplate config={config} data={data} locale="fr-FR" />;
}

export async function getStaticProps() {
  return await getAvailabilityByRegion();
}
